/**
 * SP5 Wave 3 — KPI rail data source.
 *
 * Fetches aggregate counts from `GET /api/benchmarks/stats`. The endpoint
 * filters `status='published' AND suppressed_at IS NULL` server-side so no
 * client-side defensive filtering is needed.
 *
 * Wave-1 A1e — accepts the same filter dimensions as the list query so the
 * KPI rail and the visible catalogue agree under any user-applied filter.
 * Stats and list both apply `status='published' AND suppressed_at IS NULL`
 * server-side (alignment guarantee — see `apps/api/src/routes/benchmarks.routes.ts`).
 */

import { useQuery } from '@tanstack/react-query'
import type { BenchmarkStats } from '@intelhub/shared'
import { api, buildQueryString } from '@/lib/api'

export interface BenchmarksStatsFilters {
  publisherType?: string
  reportType?: string
  topic?: string
  publisherSlug?: string
}

export function useBenchmarksStats(filters: BenchmarksStatsFilters = {}) {
  return useQuery<BenchmarkStats>({
    queryKey: ['benchmarks', 'stats', filters],
    queryFn: () =>
      api.get<BenchmarkStats>(
        `/benchmarks/stats${buildQueryString({ ...filters })}`,
      ),
    // Stats only change on admin publish/suppress — a 1-minute cache is ample
    // and lets the rail share a fresh fetch with any sibling consumers.
    staleTime: 60_000,
  })
}
